<template>
  <v-card class="recharge mw-700 mx-auto" elevation="0">
    <v-form
      v-if="!successData"
      ref="form"
      @submit.prevent="validate"
      lazy-validation
    >
      <v-row>
        <v-col cols="12" sm="8" align-self="center">
          <h1 class="mw-300">
            <span class="d-block">
              {{ $t('recharge.with') }}
            </span>
            {{ $t('recharge.pix.title') }}
          </h1>
        </v-col>
        <v-col cols="12" sm="4" align-self="center">
          <HAmount @input="getAmount" :minAmount="140" class="ml-auto" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-textarea
            @input="handleUpdateRechargeFields"
            v-model="comment"
            :label="$t('recharge.comment')"
            outlined
          />
        </v-col>
      </v-row>

      <div class="mt-5 text-right">
        <v-btn
          @click="setRechargeFields({ type: null })"
          :disabled="isLoading"
          class="mr-5"
          color="grey"
          elevation="0"
          large
          text
        >
          <v-icon left> mdi-chevron-left </v-icon>
          {{ $t('recharge.navigation.goBack') }}
        </v-btn>

        <v-btn
          @click="validate"
          :loading="isLoading"
          color="primary"
          elevation="0"
          large
        >
          {{ $t('recharge.pix.withPix') }}
        </v-btn>
      </div>
    </v-form>

    <RechargeSuccess
      v-else
      @startInterval="startRefreshInterval"
      @endInterval="clearRefreshInterval"
      ref="rechargeSuccess"
    />
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import RechargeSuccess from './formFields/RechargeSuccess'
import HAmount from '@/components/app/HAmount'

export default {
  name: 'RechargeByPix',

  components: {
    HAmount,
    RechargeSuccess,
  },

  computed: {
    ...mapGetters(['successData', 'isLoading']),
  },

  methods: {
    ...mapActions(['handleRecharge', 'refreshPixRecharge']),
    ...mapMutations(['setRechargeFields']),

    validate() {
      if (this.$refs.form.validate()) {
        this.handleRecharge()
      }
    },

    getAmount(value) {
      this.setRechargeFields({ value })
    },

    startRefreshInterval() {
      this.interval = setInterval(() => {
        this.refreshPixRecharge(this.successData.id)
      }, 5000)
    },

    clearRefreshInterval() {
      clearInterval(this.interval)
    },

    handleUpdateRechargeFields() {
      this.setRechargeFields({...{ comment: this.comment }})
    },
  },

  data() {
    return {
      comment: null,
    }
  }
}
</script>
